module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz14-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_11",
      "id": "CC_11"
    }
  }, [_vm._v(" Wally’s Bottle of Pop Float")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "AzW"
    }
  }, [_c('i', [_vm._v(" A favorite of Opie’s cool aunt. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz14-2"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("H")]), _vm._v("ere’s an easy recipe that’s a real hit with my kids. After a fresh snowfall, scoop up a big glass of fresh snow. Pour in about a half glass of Coca-Cola (cream soda’s good also). Stir and eat with a spoon. If you’re feeling really exotic, give it a squirt of chocolate syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-3"
    }
  }, [_vm._v(" Serves 1.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pz14-4"
    }
  }, [_c('i', [_vm._v("Bob Scheib, Wally’s Service—Bradford, Ohio")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "pz14-5"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "images/img-14-1.jpg",
      "id": "z14-5",
      "src": "images/img-14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txcc",
    attrs: {
      "id": "pz14-6"
    }
  }, [_c('i', [_vm._v("CHECK YOUR ANTI-FREEZE?—Bob Scheib's replica of Wally's Service Station is covered from a snowfall that's perfect for making Wally's Bottle of Pop Float. The Mayberry Squad Car Rendezvous is held at this Bradford, Ohio, site each summer.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURTESY OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBERT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOPER")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AtQv"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pz14-7"
    }
  }, [_c('i', [_vm._v("Fill ’er up at Wally’s:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pA7L"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "A7L"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-A7L-0"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A7L-0-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("FLOYD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A7L-0-1"
    }
  }, [_vm._v("You got the best pop in town.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A7L-1"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A7L-1-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("WALLY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A7L-1-1"
    }
  }, [_vm._v("Yeah.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A7L-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A7L-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("FLOYD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A7L-2-1"
    }
  }, [_vm._v("You’ve got more variety than they’ve got at the drugstore. Oh, they’ve got cherry and orange. You’ve got just about ever . . . Say, I noticed a new one in there for Huckleberry Smash. I would’ve tried it, but I already had the cap off of this Nectarine Crush.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A7L-3"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A7L-3-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("WALLY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A7L-3-1"
    }
  }, [_vm._v("Another I’ve got you oughta try—high octane ethyl.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-A7L-4"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-A7L-4-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("FLOYD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-A7L-4-1"
    }
  }, [_vm._v("Oh, that’s a new one, that high octane ethyl?")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b41545d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter11.vue
// module id = 96
// module chunks = 0